export default __webpack_public_path__ + "7a95cc9199f3b32fd6d6224026e19ada.png";